import React from 'react'
import dayjs from 'dayjs'
import Metric from 'constructicon/metric'

const CountdownMetric = ({
  endDate,
  label,
  metric,
  multiplier,
  ...props
}) => {
  const today = dayjs()
  const eventdayjs = dayjs(endDate)
  const daysDiff = eventdayjs.diff(today, 'days')
  const days = Math.max(0, daysDiff)
  const amount = days * (multiplier || 1)

  return (
    <Metric
      amount={amount}
      label={label}
      {...metric}
      {...props}
    />
  )
}

export default CountdownMetric
